const REGEXP_SCROLL_PARENT = /^(visible|hidden)/;
/**
 * Encuentra el primer elemento padre del elemento provisto que tenga scroll
 * activo.
 */
export function findScrollContainer(el: HTMLElement): HTMLElement | null {
  // eslint-disable-next-line no-nested-ternary
  return !(el instanceof HTMLElement) ||
    typeof window.getComputedStyle !== 'function'
    ? null
    : el.scrollHeight >= el.clientHeight &&
      !REGEXP_SCROLL_PARENT.test(
        window.getComputedStyle(el).overflowY || 'visible',
      )
    ? el
    : findScrollContainer(el.parentElement as HTMLElement) || document.body;
}
